import { qs, qsAll } from "../dom-helpers";
import axios from "axios";
import Modals from "../modules/Modals";

class Forms {
  constructor(formSelector) {
    this.form = formSelector;
    this.nameInput = qs(".input-name", formSelector);
    this.contactInput = qs(".input-contact", formSelector);
    this.urlInput = qs(".input-url", formSelector);
    this.alertNotification = qsAll(".alert");
    this.alertError = qs(".alert--error");
    this.alertSuccess = qs(".alert--success");
    this.alertCloseButton = qsAll(".alert__close-button");
    this.main = qs("#main");
    this._run();
  }

  _run() {
    try {
      this._registerEventListeners();
    } catch (e) {
      console.error(e); // eslint-disable-line
    }
  }

  _registerEventListeners() {
    if (this.form) {
      this.form.addEventListener("submit", (event) => {
        event.preventDefault();
        const URL = `/send/`;

        if (this._validate()) {
          const formData = new FormData(this.form);

          if (!formData.has("url")) {
            formData.append('modal', this.main.dataset.form_name);
          }

          axios
            .post(URL, formData)
            .then(() => {
              console.log("Успешно отправлено"); // eslint-disable-line
              const modals = new Modals();
              modals._handleCloseModal();
              this.alertSuccess.classList.add("alert--visible");
              setTimeout(() => {
                this.alertSuccess.classList.remove("alert--visible");
              }, 5000);
            })
            .catch((error) => {
              console.log("Произошла ошибка", error); // eslint-disable-line
              this.alertError.classList.add("alert--visible");
              setTimeout(() => {
                this.alertError.classList.remove("alert--visible");
              }, 5000);
            });
          // this.form.submit();
        }
      });
    }

    this.alertNotification.forEach((alertNotification) => {
      this.alertCloseButton.forEach((closeButton) => {
        closeButton.addEventListener("click", () => {
          alertNotification.classList.remove("alert--visible");
        });
      });
    });
  }

  _validate() {
    let valid = true;

    if (!this._validateName()) {
      valid = false;
    }

    if (!this._validateContact()) {
      valid = false;
    }

    if (!this._validateURL()) {
      valid = false;
    }

    return valid;
  }

  _validateName() {
    return true;

    const nameValue = this.nameInput.value.trim();

    if (nameValue === "") {
      alert("Пожалуйста, введите свое имя");
      return false;
    }

    if (nameValue.match(/\d/)) {
      alert('Поле "Имя" не может содержать цифры');
      return false;
    }

    return true;
  }

  _validateContact() {
    const contactValue = this.contactInput.value.trim();
    if (contactValue === "") {
      alert(
        "Поле не может быть пустым. " +
          'Пожалуйста, введите данные в формате: "@telegramName", или "skypeName" или "myEmail@.example.com" '
      );
      return false;
    }

    return true;
  }

  _validateURL() {
    return true;

    if (this.urlInput === null) {
      return true;
    }

    const urlValue = this.urlInput.value.trim();
    const urlRegex =
      /^(ftp?|http?|https?:\/\/)?([\w.-]+)\.([a-z]{2,6}\.?)(\/[\w]*)*\/?$/i;

    if (urlValue === "") {
      alert(
        'Пожалуйста, введите URL-адрес "https://example.com или example.com" '
      );
      return false;
    }

    if (!urlRegex.test(urlValue)) {
      alert(
        'Пожалуйста, введите действительный URL-адрес в формате "https://example.com или example.com" '
      );
      return false;
    }

    return true;
  }
}

export default Forms;
